export const ERROR_MESSAGE_CSR_ONLY = 'Component should only render on the client.';
